import { render, staticRenderFns } from "./direct-tier-selection.vue?vue&type=template&id=22c0cd5f&"
import script from "./direct-tier-selection.vue?vue&type=script&lang=ts&"
export * from "./direct-tier-selection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports